import React, { Component } from 'react';

import Utils from '../Utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFire } from '@fortawesome/free-solid-svg-icons'

import '../styles/Header.css';

class Header extends Component {
  // A streak of nothing is not worth a badge, so the counter appears only once
  // there is a streak to lose. The flame dims on a day the daily is still
  // unplayed, which is the whole point of showing it in the bar: yesterday's
  // streak is still standing, and today is when it can be dropped.
  renderStreak = () => {
    if (!this.props.streak) {
      return null;
    }

    return (
      <div
        className={`header-streak${this.props.streakAtRisk ? " header-streak-at-risk" : ""}`}
        title={Utils.assembleStreakString(this.props.streak, this.props.streakAtRisk)}
      >
        <FontAwesomeIcon icon={faFire} className="accolade-icon header-streak-icon" />
        <span className="header-streak-count">{this.props.streak}</span>
      </div>
    );
  }

  render() {
    return (
      <div className="header">
        <div className="header-title">
          <a href="https://play.tenwords.net">Ten Words</a>
        </div>
        { !!this.props.loggedInPlayerName &&
          <div className="header-welcome">
            {this.renderStreak()}
            <div className="header-user-name">
              Welcome, <span className="header-user-name-span" onClick={this.props.onProfileClick}>{this.props.loggedInPlayerName}</span>!
            </div>
            <div className="header-log-out" onClick={this.props.onLogoutClick}>
              [ Log Out ]
            </div>
          </div>
        }
        { !this.props.loggedInPlayerName &&
          <div className="header-log-in" onClick={this.props.onLoginClick}>
            [ Log In ]
          </div>
        }
      </div>
    );
  }
}

export default Header;
